(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-blog-2026"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
    $('.sonni-blog-2026 .sonni-blog__articles').each(function(index){

        if(!$(this).hasClass('slick-initialized')) {

            $(this).slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: true,
                infinite: false,
                swipe: true,
                prevArrow: '<button class="slick-prev"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="white"/><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="#002459"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="white"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="#002459"/></svg></button>',
                nextArrow: '<button class="slick-next"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="white"/><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="#002459"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="white"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="#002459"/></svg></button>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1.2,
                            slidesToScroll: 1,
                            arrows: false
                        }
                    }
                ]
                
            });
        }

    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-collection-2026"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
    $('.sonni-collection-2026 .sonni-collection__slider').each(function(index){

        if(!$(this).hasClass('slick-initialized')) {
            $slidesToShow = 3;
            $slidesToShow_mobile = 1.2;

            if($(this).parents('.sonni-collection').hasClass('light-background')) {
                $slidesToShow = 2;
                $slidesToShow_mobile = 2;
            }

            $(this).slick({
                slidesToShow: $slidesToShow,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                infinite: true,
                swipe: true,
                appendArrows: $(this).siblings('.sonni-collection__navigation-wrapper').find('.sonni-collection__navigation'),
                prevArrow: '<button class="slick-prev"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="white"/><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="#002459"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="white"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="#002459"/></svg></button>',
                nextArrow: '<button class="slick-next"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="white"/><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="#002459"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="white"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="#002459"/></svg></button>',
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: $slidesToShow_mobile,
                            slidesToScroll: 1,
                            variableWidth: false,
                            centerMode: false,
                            infinite: false,
                            arrows: false
                        }
                    }
                ]
                
            });
        }

    });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-difference-2026"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", () => {
        // Select all header buttons inside the accordion
        const triggers = document.querySelectorAll(".item-content__trigger");

        triggers.forEach(trigger => {
            trigger.addEventListener("click", (event) => {
                event.preventDefault();
                // Locate the wrapper item containing both header and description panel
                const currentItem = trigger.closest('.sonni-difference__item-content');
                const grid = trigger.closest('.sonni-difference__grid');
                
                // Loop through all items to close any item that isn't the clicked one
                grid.querySelectorAll(".sonni-difference__item-content").forEach(item => {
                    if (item !== currentItem) {
                        item.classList.remove("active");
                    }
                });

                // Toggle visibility classes on the clicked element
                currentItem.classList.toggle("active");
                $(currentItem.querySelector('.item-content__wrapper')).slideToggle();
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-key-ingredients-2026"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", () => {
        // Select all header buttons inside the accordion
        const headers = document.querySelectorAll(".sonni-key-ingredients-2026 .accordion-header");

        headers.forEach(header => {
            header.addEventListener("click", () => {
                // Locate the wrapper item containing both header and description panel
                const currentItem = header.parentElement;
                const accordionItems = Array.from(currentItem.parentNode.children);
                
                // Loop through all items to close any item that isn't the clicked one
                accordionItems.forEach(item => {
                    if (item !== currentItem) {
                        item.classList.remove("active");
                        $(item.querySelector('.accordion-content')).slideUp();
                    }
                });

                // Toggle visibility classes on the clicked element
                currentItem.classList.toggle("active");
                $(currentItem.querySelector('.accordion-content')).slideToggle();
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-landing-product-v2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    $(document).on('click','.sonni-landing-product-v2__right .media-container .button--navigation', function(e) {
      e.preventDefault();
      if($(this).hasClass('button--next-slide')) {
        $currentImg = $(this).parent('.media-container').find('img.active');
        $nextImg = $currentImg.next();

        if($nextImg.length === 0) {
          $nextImg = $(this).parent('.media-container').find('img').first();
        }

        $currentImg.removeClass('active');
        $nextImg.addClass('active');
      } else {
        $currentImg = $(this).parent('.media-container').find('img.active');
        $prevImg = $currentImg.prev();

        if($prevImg.length === 0) {
          $prevImg = $(this).parent('.media-container').find('img').last();
        }

        $currentImg.removeClass('active');
        $prevImg.addClass('active');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-learn-more-2026"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", () => {
        // Select all header buttons inside the accordion
        const headers = document.querySelectorAll(".sonni-learn-more-2026 .accordion-header");

        headers.forEach(header => {
            header.addEventListener("click", () => {
                // Locate the wrapper item containing both header and description panel
                const currentItem = header.parentElement;
                const accordionItems = Array.from(currentItem.parentNode.children);
                
                // Loop through all items to close any item that isn't the clicked one
                accordionItems.forEach(item => {
                    if (item !== currentItem) {
                        item.classList.remove("active");
                        $(item.querySelector('.accordion-content')).slideUp();
                    }
                });

                // Toggle visibility classes on the clicked element
                currentItem.classList.toggle("active");
                $(currentItem.querySelector('.accordion-content')).slideToggle();
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-multi-product-2026"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function(){
        const swithcher_items = document.querySelectorAll('.product-switcher li');

        swithcher_items.forEach((item) => {
            item.addEventListener('mouseover', function() {
                item.closest('.sonni-multi-product-2026').querySelectorAll('.product-item').forEach((product_item) => {
                    product_item.classList.remove('active');
                });
                item.closest('.sonni-multi-product-2026').querySelector('.product-item:nth-child(' + item.dataset.index + ')').classList.add('active');
            });
        });
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-reviews-2026"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', () => {
  $('.sonni-reviews-2026 .sonni-reviews__slider').each(function(index){

      if(!$(this).hasClass('slick-initialized')) {

          $(this).slick({
              slidesToShow: 3,
              slidesToScroll: 1,
              arrows: true,
              dots: true,
              infinite: true,
              swipe: true,
              prevArrow: '<button class="slick-prev"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="white"/><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="#002459"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="white"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="#002459"/></svg></button>',
              nextArrow: '<button class="slick-next"><svg width="13" height="24" viewBox="0 0 13 24" fill="none" xmlns="http://www.w3.org/2000/svg"><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="white"/><line y1="-0.5" x2="16.9706" y2="-0.5" transform="matrix(0.707107 0.707107 0.707107 -0.707107 1 0)" stroke="#002459"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="white"/><line x1="0.646447" y1="23.6464" x2="12.6464" y2="11.6464" stroke="#002459"/></svg></button>',
              responsive: [
                  {
                      breakpoint: 768,
                      settings: {
                          slidesToShow: 1,
                          slidesToScroll: 1,
                          arrows: false
                      }
                  }
              ]
              
          });
      }

  });


});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sonni-values-2026"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener("DOMContentLoaded", () => {
        // Select all header buttons inside the accordion
        const headers = document.querySelectorAll(".sonni-values-2026 .accordion-header");

        headers.forEach(header => {
            header.addEventListener("click", () => {
                // Locate the wrapper item containing both header and description panel
                const currentItem = header.parentElement;
                const accordionItems = Array.from(currentItem.parentNode.children);
                
                // Loop through all items to close any item that isn't the clicked one
                accordionItems.forEach(item => {
                    if (item !== currentItem) {
                        item.classList.remove("active");
                        $(item.querySelector('.accordion-content')).slideUp();
                    }
                });

                // Toggle visibility classes on the clicked element
                currentItem.classList.toggle("active");
                $(currentItem.querySelector('.accordion-content')).slideToggle();
            });
        });
    });

  } catch(e) { console.error(e); }
})();
})();
